// extracted by mini-css-extract-plugin
export default {"bubbleRectangle":"SpeechBubble_bubbleRectangle__AByMp","hideTail":"SpeechBubble_hideTail__wlmNG","left":"SpeechBubble_left__9pCry"};